import React from 'react';
import './component013.less';

import ImgPoint from '../../../../../assets/animation_point.gif';
import { useStore } from '../../../store';

interface IComponent013Props {
  content: string;
  className: string;
}

const Component013: React.FunctionComponent<IComponent013Props> = ({
  content,
  className,
}) => {
  const ap_videoRef =
    React.useRef() as React.MutableRefObject<HTMLVideoElement>;
  const ap_videoContainerRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const [state, setState] = React.useState({
    conversation: 0,
    animationPassword: false,
    coveredAnswer: 6,
  });
  const showAnimationPassword = () => {
    setState({
      ...state,
      animationPassword: true,
    });
    ap_videoRef.current.play();
  };
  const { language } = useStore();
  return (
    <div
      ref={ap_videoContainerRef}
      className={`password-section video-container component ${className}`}
      onClick={showAnimationPassword}
    >
      <div
        style={{ display: state.animationPassword ? 'none' : '' }}
        className="password-section-text"
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <img
        className={`point ${state.animationPassword ? 'hide' : ''}`}
        src={ImgPoint}
        alt=""
      />
      <video
        style={{
          position: 'relative',
          visibility: state.animationPassword ? 'visible' : 'hidden',
        }}
        key={language}
        ref={ap_videoRef}
        width="100%"
        controls={false}
        autoPlay={false}
      >
        <source
          src={
            language === 'cn'
              ? '/videos/animationpassword.mov'
              : language === 'en'
              ? '/videos/animationpassword-en.mov'
              : '/videos/animationpassword-sc.mp4'
          }
          type="video/mp4"
        />
        Your browser does not support HTML video.
      </video>
    </div>
  );
};

export default Component013;
